import { Fragment } from "react";
import StaedteError from "./Error";

export default function CityName( params ) {
    
    const cityData = params.data;

    let errorOccured = undefined !== cityData.errors;
    if ( errorOccured ) {
        // TODO: How to handle missing detail data?
        return(
            <Fragment>
                <StaedteError />
            </Fragment>
        );
    } else if ( undefined === cityData || 0 === cityData.length ) {
        return;
    }

    return(
        <>
            {cityData.city_name}
        </>
    );

}